import type { OpenJobsState } from 'src/types/open-jobs';

export const initialState: OpenJobsState = {
  data: {},
  source: {},
  isLoading: true,
};
